var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.906 6.073a.8.8 0 0 0-.24.594v2.666l-.75-.75a.8.8 0 0 0-.583-.229.8.8 0 0 0-.583.23.8.8 0 0 0-.23.583q0 .354.23.583l2.167 2.167a.8.8 0 0 0 .583.25.8.8 0 0 0 .583-.25L10.25 9.75a.8.8 0 0 0 .23-.583.8.8 0 0 0-.23-.584.8.8 0 0 0-.583-.229.8.8 0 0 0-.584.23l-.75.75V6.666a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24m-5.24-1.906v9.166h11.667V4.167zm0 10.833Q.98 15 .49 14.51A1.6 1.6 0 0 1 0 13.333V2.938q0-.292.094-.563.093-.27.281-.5L1.417.605q.228-.293.573-.449Q2.333 0 2.708 0h9.584q.376 0 .718.156.344.156.573.448l1.042 1.271q.188.23.281.5t.094.563v10.395q0 .688-.49 1.177-.489.49-1.177.49zM2 2.5h11l-.708-.833H2.708z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive_icon.22b073f0c9ea91c344cf6e946d6391e7.svg";
export { ForwardRef as ReactComponent };